import component from './';

/** @type {UICore.ComponentMeta} */
const CardComponentMeta = {
  id: 'w-card',
  name: '卡片',
  icon: 'https://vfiles.gtimg.cn/vupload/20211101/d65be91635751798819.png',
  category: '布局',
  component,
  slots: [{
    id: 'default',
    containerRef: 'content'
  }, {
    id: 'action',
    containerRef: 'actions'
  }, {
    id: 'footer',
    containerRef: 'footer'
  }],
  bindings: [{
    id: '封面图',
    prop: 'coverImage',
    checkData: s => s.type === 'string'
  }, {
    id: '标题',
    prop: 'title',
    checkData: s => s.type === 'string'
  }],
  events: [{
    id: 'click',
    name: '点击整个卡片'
  }, {
    id: 'clickHeader',
    name: '点击标题区'
  }, {
    id: 'mouseenter',
    name: '鼠标进入卡片'
  }, {
    id: 'mouseleave',
    name: '鼠标离开卡片'
  }],
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'title',
      type: 'string',
      title: '标题'
    }, {
      id: 'isClickable',
      type: 'boolean',
      title: '卡片可点击'
    }, {
      id: 'withFooter',
      type: 'boolean',
      title: '启用底部操作列'
    }, {
      id: 'background',
      type: 'string',
      group: '风格',
      title: '背景',
      enum: [{
        value: 'default',
        label: '白色'
      }, {
        value: 'transparent',
        label: '透明'
      }, {
        value: 'blur',
        label: '磨砂'
      }]
    }, {
      id: 'isCompact',
      type: 'boolean',
      group: '风格',
      title: '紧凑'
    }, {
      id: 'withBorder',
      type: 'boolean',
      group: '风格',
      title: '边框'
    }, {
      id: 'withBorderRadius',
      type: 'boolean',
      group: '风格',
      title: '圆角'
    }, {
      id: 'withBoxShadow',
      type: 'boolean',
      group: '风格',
      title: '阴影'
    }, {
      id: 'withCoverImage',
      type: 'boolean',
      group: '风格',
      title: '带图片'
    }, {
      id: 'coverImage',
      type: 'string',
      group: '风格',
      title: '封面图',
      condition: 'props.withCoverImage'
    }, {
      id: 'className',
      type: 'string',
      group: '高级配置'
    }, {
      id: 'css',
      type: 'string',
      title: '自定义CSS',
      ui: {
        settings: {
          multipleLine: true
        }
      },
      group: '高级配置'
    }]
  },
  getActions({
    layout,
    replaceCompWith
  }) {
    return [{
      title: '拆除卡片',
      icon: 'fa fa-scissors',
      desc: '拆除卡片，但是保留里面的内容',
      execute: () => replaceCompWith(...(layout.children || []))
    }];
  },
  stylePanel: {
    selectors: [{
      selector: '>.w-card-header',
      name: '标题',
      pseudoClasses: [{
        name: '常态',
        selector: '',
        visible: true,
        defaultSelect: true
      }]
      // 默认注入static和hover
    }, {
      selector: '>.w-card-content',
      name: '内容区域'
    }, {
      selector: '>.w-card-footer',
      name: '底部区域'
    }]
  }
};
export default CardComponentMeta;